class GraphicCard {
	static fromId(id, search) {
		let inst = new GraphicCard(id,search);
		return inst.card();
	}

	constructor(id, search) {
		this._id = id;
		this._search = search;
	}
	
	card() {
		return img('graphic-card', graphicSrc(this._id), {
			'click': this.select.bind(this)
		})
	}

	select() {
		this._search.select(this._id);
	}
}
